<template>
  <span>
    <span v-if="value === null">
        <v-icon color="primary">mdi-loading mdi-spin mdi-anim-1s</v-icon>
      </span>
      <span v-else-if="value === undefined">-</span>
      <span v-if="value === false">
        <v-tooltip bottom max-width="400">
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="grey" small v-bind="attrs" v-on="on">mdi-refresh</v-icon>
          </template>
          <span>
            {{ $t('actualisation') }}
          </span>
        </v-tooltip>
      </span>
      <span v-else-if="value === 0">+30</span>
      <span v-else>{{ value }}</span>
  </span>
</template>

<script>
export default {
  name: 'Position',
  props: ['value', 'previous'],
}
</script>

<i18n>
{
  "en": {
    "actualisation": "Updating this position has encountered an error and will be restarted in a few minutes."
  },
  "es": {
    "actualisation": "La actualización de esta posición ha detectado un error y se reiniciará en unos minutos."
  },
  "fr": {
    "actualisation": "L'actualisation de cette position a rencontré une erreur et sera relancée dans quelques minutes."
  },
  "it": {
    "actualisation": "L'aggiornamento di questa posizione ha riscontrato un errore e verrà riavviato tra qualche minuto."
  },
  "pt": {
    "actualisation": "A atualização desta posição encontrou um erro e será reiniciada em alguns minutos."
  },
  "pl": {
    "actualisation": "Aktualizacja tej pozycji napotkała błąd i zostanie wznowiona za kilka minut."
  }
}
</i18n>
